import { atom } from 'jotai'

import { type ShipmentOrdersListExEntity } from '@/libs/api'

/**
 * 配車板のドロワー内配送依頼の詳細で表示する配送依頼情報
 */
export const vehicleDispatchBoardsShipmentOrderDetailAtom =
  atom<ShipmentOrdersListExEntity | null>(null)

vehicleDispatchBoardsShipmentOrderDetailAtom.debugLabel =
  'vehicleDispatchBoardsShipmentOrderDetailAtom'
